import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import "./FormsList.css";

const FormsSetsListHeaderComponent = ({
  globalFilterValue,
  onGlobalFilterChange,
  clearFilter,
  handleCreateFormSet,
}) => {
  const toast = useRef(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [newFormSetName, setNewFormSetName] = useState("");

  const openDialog = () => setDialogVisible(true);
  const hideDialog = () => {
    setDialogVisible(false);
    setNewFormSetName("");
  };

  const handleSave = async () => {
    if (!newFormSetName.trim()) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Formset name cannot be empty.",
        life: 3000,
      });
      return;
    }
    await handleCreateFormSet({ name: newFormSetName });
    hideDialog();
  };

  const dialogFooter = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={hideDialog}
        className="p-button-text"
        style={{
          backgroundColor: "#D97A07",
          border: "none",
          color: "#fff",
          fontFamily: "poppins",
        }}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={handleSave}
        autoFocus
        style={{
          backgroundColor: "#0D2E4D",
          border: "none",
          color: "#fff",
          fontFamily: "poppins",
        }}
      />
    </div>
  );

  return (
    <div className="flex justify-content-between form-list-header">
      <Toast ref={toast} />

      <div className="flex search-container">
        <IconField iconPosition="right" className="search-field">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
            style={{ fontFamily: "poppins" }}
            className="search-input"
          />
        </IconField>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Clear"
          outlined
          onClick={clearFilter}
          className="clear-button"
          style={{
            backgroundColor: "#D97A07",
            border: "none",
            color: "#fff",
            marginLeft: "10px",
            fontFamily: "poppins",
          }}
        />
      </div>
      <div className="flex">
        <Button
          label="Create"
          icon="pi pi-plus"
          className="p-button-success"
          onClick={openDialog}
          style={{
            backgroundColor: "#0D2E4D",
            border: "none",
            color: "#fff",
            fontFamily: "poppins",
            whiteSpace: "nowrap",
            minWidth: "110px",
            marginLeft: "10px",
          }}
        />
      </div>
      <Dialog
        header="Create New Formset"
        visible={dialogVisible}
        style={{ width: "50vw" }}
        onHide={hideDialog}
        footer={dialogFooter}
      >
        <div className="p-fluid">
          <div className="p-field">
            <label htmlFor="name">Name</label>
            <InputText
              id="name"
              value={newFormSetName}
              onChange={(e) => setNewFormSetName(e.target.value)}
              required
              autoFocus
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default FormsSetsListHeaderComponent;
